import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Confiance } from "./components/Confiance";
import { TrustMarquee } from "./components/TrustMarquee";
import { Services } from "./components/Services";
import { Realisations } from "./components/Realisations";
import { Process } from "./components/Process";
import { Metrics } from "./components/Metrics";
import { WhyUs } from "./components/WhyUs";
import { Audiences } from "./components/Audiences";
import { CtaBand } from "./components/CtaBand";
import { Footer } from "./components/Footer";
import { CookieBanner } from "./components/CookieBanner";
import { ScrollToTop } from "./components/ScrollToTop";
import { Seo } from "./components/Seo";
import MentionsLegales from "./pages/MentionsLegales";
import Confidentialite from "./pages/Confidentialite";
import CGU from "./pages/CGU";
import Cookies from "./pages/Cookies";

const Landing = () => {
  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white font-body">
      <Seo
        title="PDR France — Débosselage sans peinture (DSP) · Grêle & Smart Repair"
        description="Spécialiste du débosselage sans peinture : réparation grêle, Smart Repair, carrosserie aluminium & carbone. Utilitaires, camping-cars, poids lourds. Devis sous 24h, véhicule de prêt, partenaires assurances."
        path="/"
      />
      <Navbar />
      <main>
        <Confiance />
        <Hero />
        <TrustMarquee />
        <Services />
        <Realisations />
        <Process />
        <Metrics />
        <WhyUs />
        <Audiences />
        <CtaBand />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/confidentialite" element={<Confidentialite />} />
            <Route path="/cgu" element={<CGU />} />
            <Route path="/cookies" element={<Cookies />} />
          </Routes>
          <CookieBanner />
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
